import { ICellRendererParams } from "@ag-grid-community/core";
import { Center, HStack, StackProps, Text, Tooltip } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { MaybernTableDropdownCellEditorParams } from "shared/components/table/maybern/MaybernTableDropdownCellEditor";
import { getMaybernTableCellError } from "shared/components/table/maybern/MaybernTableErrors";
import { ArrowDropDownIcon } from "shared/icons/ArrowDropDownIcon";
import { ErrorIcon } from "shared/icons/ErrorIcon";

export const MaybernTableDropdownCellEditorRenderer: React.FC<
  ICellRendererParams & StackProps
> = ({ colDef, column, node, valueFormatted, context, ...stackProps }) => {
  const { t } = useTranslation(["common"]);
  const { title } =
    (colDef?.cellEditorParams as
      | MaybernTableDropdownCellEditorParams
      | undefined) ?? {};
  const isEditable = column?.isCellEditable(node);
  const error = getMaybernTableCellError({ column, node, context });
  return (
    <HStack
      w="100%"
      paddingStart="16px"
      spacing="0px"
      opacity={isEditable ? 1 : 0.5}
      {...stackProps}
    >
      <Text
        flex="1"
        minWidth="0"
        overflow="hidden"
        textOverflow="ellipsis"
        textColor={valueFormatted ? undefined : "gray.400"}
      >
        {valueFormatted || title || t("common:select")}
      </Text>
      <Center w="38px" h="38px" mr="-1px">
        <ArrowDropDownIcon color="gray.500" />
      </Center>
      {error && (
        <Tooltip openDelay={0} bg="red.600" color="white" label={error}>
          <ErrorIcon ml="-8px" mr="8px" />
        </Tooltip>
      )}
    </HStack>
  );
};
